import { featureFlagClient } from '@ringcentral/rwc-utils/src/feature-flag-client';
import { FEATURE_FLAG_PRIORITY } from '@ringcentral/rwc-utils/src/feature-flag/constant';
import FfsController from '@ringcentral/rwc-utils/src/feature-flag/controller/ffs/ffs-controller';
import getConfig from '@ringcentral/rwc-utils/src/config';
import { readLocallyStored } from '@ringcentral/rwc-utils/src/local-storage';

const enableFfs = Boolean(
    (readLocallyStored('ffs', {}, true) as Record<string, unknown>)?.enabled ??
        getConfig('ffs')?.enabled
);

featureFlagClient.initialize();

if (enableFfs) {
    const ffsInstance = FfsController.getInstance();
    featureFlagClient.addSource(ffsInstance, FEATURE_FLAG_PRIORITY.FFS, flag => flag);
}
